import { createModule } from '@evyweb/ioctopus';

import { walletService } from '../../infrastructure/entry.browser.js';
import { diSymbolMap } from '../types.js';

/**
 * Creates and configures the wallet module.
 *
 * @returns The configured wallet module.
 */
export function createWalletModule(): ReturnType<typeof createModule> {
  const walletModule = createModule();

  // Services
  walletModule.bind(diSymbolMap.IWalletService).toHigherOrderFunction(walletService);

  return walletModule;
}
